import {CrudService} from '@ngx-ivengi/crud';
import {Room} from './room.model';

export class RoomService extends CrudService<Room> {
  public entityType = Room;
}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/room/room.service.ts